import React from 'react'
import PropTypes from 'prop-types'
import { Info } from '../../../assets/icons'
import theme from '../../../styled/theme'
import { Text1Bold, SubTitle } from '../text'
import { Container, Header, MessageWrapper } from './styled'

const InfoCardHome = ({ title, message, children }) => (
	<Container>
		<Header>
			<Info size={24} color={theme.colors.brand.lightBlue} />
			{title && <Text1Bold size="16px">{title}</Text1Bold>}
		</Header>
		<MessageWrapper>
			<SubTitle>{message || children}</SubTitle>
		</MessageWrapper>
	</Container>
)

export default InfoCardHome
